import * as Sentry from '@sentry/nextjs';
import { getCurrentEnvironment } from '@pb/services';
import { tracesSampler } from './sentry.utils';
import { TRACES_SAMPLE_RATE } from './sentry.constants';
import { TSentryServerConfig } from '.';

// This file configures the initialization of Sentry on the server.
// The config you add here will be used whenever the server handles a request.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

// Set Data Source Name (DSN) via default env vars or manually supply `dsn` below
const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

export const initSentryServer = ({
    debug = false,
    dsn,
    tracesSampleRate = TRACES_SAMPLE_RATE,
}: TSentryServerConfig) => {
    Sentry.init({
        debug,
        dsn: SENTRY_DSN || dsn,
        environment: getCurrentEnvironment(),
        tracesSampler: /* istanbul ignore next */ samplingContext =>
            tracesSampler(samplingContext, tracesSampleRate),
        // ...
        // Note: if you want to override the automatic release value, do not set a
        // `release` value here - use the environment variable `SENTRY_RELEASE`, so
        // that it will also get attached to your source maps
    });
};
